import { useParams } from 'react-router-dom';
import SiteHeader from './SiteHeader';
import SiteFooter from './SiteFooter';
import PublicForm from './PublicForm';

const SurveyPage = () => {
  const { formId } = useParams();
  return (
    <div className="min-h-screen bg-cream-50" data-testid="survey-page">
      <SiteHeader active="" />
      <section className="relative overflow-hidden bg-[#1a0d10] text-white py-14 md:py-20 px-4 md:px-6">
        <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_top_right,rgba(124,29,51,0.25),transparent_55%),radial-gradient(ellipse_at_bottom_left,rgba(217,161,91,0.12),transparent_60%)]" />
        <div className="absolute inset-0 grain" />
        <div className="max-w-3xl mx-auto relative z-10 text-center">
          <p className="eyebrow text-white/50 mb-4">We&apos;d love your honest take</p>
          <h1 className="font-display text-5xl sm:text-6xl font-medium tracking-tighter leading-[0.95]">
            Tell us how <span className="bg-gradient-to-br from-[#c98a4b] via-[#d9a15b] to-[#f0d3a0] bg-clip-text text-transparent italic">it went.</span>
          </h1>
        </div>
      </section>
      <section className="py-12 md:py-16 px-4 md:px-6">
        <div className="max-w-3xl mx-auto">
          <PublicForm formId={formId} />
        </div>
      </section>
      <SiteFooter />
    </div>
  );
};

export default SurveyPage;
